import { moveTimeStreamAsset, AssetId, ProjectId, getAsset } from 'owa-timestream-store';
import pageToDocumentCoordinates from './pageToDocumentCoordinates';

export default function moveAssetToPageCoordinates(
    pageX: number,
    pageY: number,
    projectId: ProjectId,
    existingAssetId: AssetId
) {
    const { x, y } = pageToDocumentCoordinates(pageX, pageY);
    const { bounds } = getAsset(projectId, existingAssetId);
    moveTimeStreamAsset(projectId, existingAssetId, x - bounds.x, y - bounds.y);
}
